<template>
  <div v-if="game">
    <div class="board">
      <div class="board-small" v-for="(bp, bpc) in boardPieces" v-bind:key="`bp_${bpc}`">
        <div class="board-row" v-bind:key="`row_${rowc}`" v-for="(row, rowc) in bp">
          <div class="board-col" v-bind:key="`${bpc}_${rowc}_${colc}`" v-for="(col, colc) in row" @click.prevent="putAPiece(bpc, rowc, colc)">
            <div class="board-piece" :ref="`${bpc}_${rowc}_${colc}_piece`" :class="col"></div>
          </div>
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'pentago',
  computed: {
    ...mapState({
      game: state => state.game.currentGame,
    }),
    ...mapGetters(['isLoggedIn', 'getCurrentUser', 'getUserData']),
    boardPieces() {
      const bp0 = [
        [' ', ' ', 'b'],
        [' ', ' ', ' '],
        [' ', ' ', ' '],
      ];

      const bp1 = [
        [' ', 'w', ' '],
        [' ', 'w', ' '],
        [' ', ' ', ' '],
      ];

      const bp2 = [
        [' ', ' ', ' '],
        [' ', ' ', ' '],
        [' ', ' ', ' '],
      ];

      const bp3 = [
        [' ', ' ', ' '],
        [' ', ' ', ' '],
        [' ', ' ', ' '],
      ];

      return [bp0, bp1, bp2, bp3];
    },
    visibleBoard() {
      return this.game.board;
      // @TODO: fix after boardHistory is active
      // if (this.clientSideData.moveIndex === -1) {
      //   return this.game.board;
      // }
      // return this.game.boardHistory[this.clientSideData.moveIndex];
    },
  },
  props: ['config', 'clientSideData'],
  created() {
    this.$store.dispatch('createGame', this.config);
  },
  destroyed() {
    this.$store.dispatch('endGame');
  },
  methods: {
    isPlayable(row, col) {
      return this.game.isPlayable(row, col);
    },
    isBase(row, col) {
      return this.game.isBase(row, col);
    },
    mySide() {
      return this.game.playerInfo.find(pi => pi.player === this.getCurrentUser.uid).side;
    },
    putAPiece(i, c, r) {
      if (this.game.finished) {
        return;
      }
      if (this.mySide() !== this.game.getTurnPlayerSide()) {
        return;
      }

      console.log(r);
    },
    handleClick(row, col) {
      if (this.game.finished) {
        return;
      }
      if (this.mySide() !== this.game.getTurnPlayerSide()) {
        return;
      }
      const index = this.game.playableSquares.indexOf(`${row}_${col}`);

      if (index === -1) {
        this.game.setPlayableSquares(row, col);
      } else {
        const from = this.game.helper.getNumValues(this.game.askedFor);
        const to = [row, col];

        // this is for animation
        // if (from[0] === to[0]) {
        //   this.setBeforeEnterCoords(from, to, 'col');
        // } else {
        //   this.setBeforeEnterCoords(from, to, 'row');
        // }

        // this.game.move(from, to);
        this.$root.$emit('move', { from, to });
        // this.game.altMove(from, to);
        // setTimeout(() => {
        //   // this.animate(to);
        // }, 0);
      }
    },
    // setBeforeEnterCoords(from, to, colOrRow) {
    //   let diff = 0;
    //   if (colOrRow === 'col') {
    //     diff = to[1] - from[1];
    //     this.coords = { top: '10px', left: `${-50 * diff}px` };
    //   } else {
    //     diff = to[0] - from[0];
    //     this.coords = { top: `${-50 * diff}px`, left: 0 };
    //   }
    // },
    // animate(to) {
    //   this.$refs[`${to[0]}_${to[1]}_piece`][0].velocity({ left: 0, top: 10 }, 140, 'ease-in-out');
    // },
    // beforeEnter(el) {
    //   el.style.top = this.coords.top;
    //   el.style.left = this.coords.left;
    // },
  },
  data() {
    return {
      coords: {},
    };
  },
};
</script>

<style scoped lang="scss">
  // $w: 110px;
  $w: 6.2vw;

  @mixin pentagoboard($w) {
    $b: $w * 6.15;
    .board {
      position: relative;
      width: $b;
      height: $b;
      margin: 0 auto;
      background: transparent;
      &:after {
        $b_bg: $w * 5.5;
        content: "";
        background: #fff;
        width: $b_bg;
        height: $b_bg;
        position: absolute;
        z-index: 1;
        top: 0;
        left: 0;
        margin: ($b - $b_bg) / 2;
        box-shadow: $w/40 $w/40 8px 1px rgba(0,0,0,.8);
        // margin: 0 auto;
      }
      // zoom: 0.5;
      // left: 50%;
      // transform: translateX(-50%);
    }
    .board-small {
      position: relative;
      z-index: 2;
      float: left;
      // background: #c30e20;
      background: #b82325;
      background: #b82121;
      // background: darkred;
      border-radius: $w / 4;
      margin: $w / 30;
      text-align: center;
      line-height: $w;
      box-shadow: $w/40 $w/40 8px 1px rgba(0,0,0,.8);

    }

    .board-row {
      width: $w * 3;
    }
    $h: $w / 1.88;
    $h: $w / 1.7;
    .board-col {
      height: $w;
      width: $w;
      float: left;
      position: relative;
      z-index: 3;
      &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: $h;
        height: $h;
        margin: ($w - $h) / 2;
        border-radius: $w;
        background: rgba(0,0,0,0.15);
        box-shadow: inset $h/10 $h/10 $h/8 rgba(0,0,0,.35);
      }
    }
    .board-piece {
        cursor: pointer;
      position: relative;
      width: $h / 1.05;
      height: $h / 1.05;
      top: 50%;
      left: 50%;
      z-index: 10;
      transform: translate(-50%, -50%);
      border-radius: $h;
      &.b {
        background: #080808;
        // background: #111;
        box-shadow:
                    inset $h/20 $h/20 4px 1px rgba(255,255,255,.1),
                    inset $h/20 $h/20 8px 1px rgba(255,255,255,.05),
                    $h/20 $h/20 8px 1px rgba(0,0,0,.8);
                    // inset 0 0 0px $h/8 rgba(255,255,255,.3),
                          // $h/10 $h/10 $h/8 rgba(0,0,0,.8);
      }
      &.w {
        background: #fff;
        box-shadow: inset $h/20 $h/20 8px 1px rgba(255,255,255,.15),
                    inset $h/-20 $h/-20 8px 1px rgba(0,0,0,.5),
                          $h/20 $h/20 8px 1px rgba(0,0,0,.8);
        // box-shadow:;
      }
    }
  }

  @include pentagoboard($w);
  // @media (max-width: 1791.98px) {
    // $w: 60.12px;
    // @include board($w);
  // }

  @media (max-width: 991.98px) {
    $w: 15.3vw;
    @include pentagoboard($w);
  }

  .fade-leave-active {
    transition: all .14s;
  }
  .fade-leave-to {
    opacity: 0;
    transform: scale(0.2);
  }
</style>
